$(document).ready(function () {
    const shopDataLayer = getShopDataLayer();

    $(".p-final-price-wrapper").appendTo(".p-detail-inner-header");
    $(".p-detail .add-to-cart-button").text(shopDataLayer.productDetail.buttonText);
    if (shopDataLayer.productDetail.productsAlternative) {
        $("<h2 class='products-additional-title'>" + shopDataLayer.productDetail.productsAlternative + "</h2>").prependTo("#productsAlternative");
    }

    initShortDescriptionTabs();
    initParametersTab();
    initLongDescription();
    initFaq();
    initVariantsTooltips();
});

function initShortDescriptionTabs() {
    const $shortDesc = $(".p-short-description");
    const $tabs = $shortDesc.find("> .tab[data-title]");

    if ($tabs.length === 0) {
        return;
    }

    const $sections = $("<div class='detail-sections'><div class='detail-sections__titles'></div><div class='detail-sections__texts'></div></div>");
    const $titles = $sections.find(".detail-sections__titles");
    const $texts = $sections.find(".detail-sections__texts");

    $tabs.each(function (index) {
        const $tab = $(this);
        const title = $tab.attr("data-title");
        const activeClass = index === 0 ? " active" : "";

        $("<span class='detail-sections__title" + activeClass + "' data-index='" + index + "'>" + title + "</span>")
            .appendTo($titles);

        $tab
            .removeClass("tab")
            .removeAttr("data-title")
            .attr("data-index", index)
            .addClass("detail-sections__text" + activeClass)
            .appendTo($texts);
    });

    $sections.appendTo(".p-data-wrapper");

    $(document).on("click", ".detail-sections__title:not(.active)", function () {
        if ($(this).hasClass("detail-sections__title--scroll")) {
            const $faq = $("#faq");
            if ($faq.length) {
                $("html, body").animate({ scrollTop: $faq.offset().top - 40 }, 400);
            }
            return;
        }

        const index = $(this).attr("data-index");
        $(".detail-sections__title.active, .detail-sections__text.active").removeClass("active");
        $(this).addClass("active");
        $(".detail-sections__text[data-index='" + index + "']").addClass("active");
    });
}

function initFaq() {
    const faqConfig = getShopDataLayer().faq;

    if (!Array.isArray(faqConfig.items) || !faqConfig.title) {
        return;
    }

    // Label popisného parametru se seznamem FAQ id — musí sedět na pojmenování
    // parametru v adminu dané mutace
    const parameterLabel = (faqConfig.parameterLabel || "faq").toLowerCase();

    let faqIds = [];

    $(".p-detail .detail-parameters tr").each(function () {
        const label = $(this).find(".row-header-label").text().trim().toLowerCase();
        if (label.indexOf(parameterLabel) > -1) {
            $(this).hide();
            faqIds = $(this).find("td").text().split(",").map(function (v) { return v.trim(); }).filter(Boolean);
        }
    });

    if (faqIds.length === 0) {
        return;
    }

    const matched = faqIds
        .map(function (id) { return faqConfig.items.find(function (f) { return String(f.id) === id; }); })
        .filter(Boolean);

    if (matched.length === 0) {
        return;
    }

    const title = faqConfig.title;
    const tabTitle = faqConfig.tabTitle || title;
    const $faq = $("<section class='faq' id='faq'><h2 class='faq__title'>" + title + "</h2><div class='faq__inner'></div></section>");
    const $inner = $faq.find(".faq__inner");

    matched.forEach(function (q) {
        $("<div class='faq__item'><div class='faq__question'>" + q.title + "</div><div class='faq__answer'>" + q.text + "</div></div>").appendTo($inner);
    });

    $faq.appendTo(".p-detail");

    $(document).on("click", ".faq__question", function () {
        $(this).parent().toggleClass("active");
        $(this).next(".faq__answer").stop(true, true).slideToggle(300);
    });

    if ($(".detail-sections__titles").length) {
        $("<span class='detail-sections__title detail-sections__title--scroll'>" + tabTitle + "</span>").appendTo(".detail-sections__titles");
    }
}

function initParametersTab() {
    const $paramBlock = $(".p-param-block");
    if ($paramBlock.length === 0) {
        return;
    }

    const shopDataLayer = getShopDataLayer();
    const hidden = (shopDataLayer.productDetail.parametersHidden || []).map(function (s) { return s.toLowerCase(); });
    const $table = $paramBlock.find(".detail-parameters").clone();

    $table.find("tr").each(function () {
        const label = $(this).find(".row-header-label").text().trim().toLowerCase();
        const isHidden = hidden.some(function (h) { return label.indexOf(h) > -1; });
        if (isHidden) {
            $(this).remove();
        }
    });

    if ($table.find("tr").length === 0) {
        $paramBlock.hide();
        return;
    }

    let $sections = $(".detail-sections");
    if ($sections.length === 0) {
        $sections = $("<div class='detail-sections'><div class='detail-sections__titles'></div><div class='detail-sections__texts'></div></div>");
        $sections.appendTo(".p-data-wrapper");
    }

    const $titles = $sections.find(".detail-sections__titles");
    const $texts = $sections.find(".detail-sections__texts");

    const existingIndices = $texts.find(".detail-sections__text").map(function () {
        return parseInt($(this).attr("data-index"), 10);
    }).get();
    const newIndex = (Math.max(-1, ...existingIndices) + 1).toString();

    const title = shopDataLayer.productDetail.parametersTabTitle;
    if (!title) {
        return;
    }
    const noActive = $texts.find(".detail-sections__text.active").length === 0;
    const activeClass = noActive ? " active" : "";

    const $newTitle = $("<span class='detail-sections__title detail-sections__title--parameters" + activeClass + "' data-index='" + newIndex + "'>" + title + "</span>");
    const $newText = $("<div class='detail-sections__text" + activeClass + "' data-index='" + newIndex + "'></div>").append($table);

    const $existingTitles = $titles.children(".detail-sections__title");
    if ($existingTitles.length >= 1) {
        $newTitle.insertAfter($existingTitles.eq(0));
    } else {
        $newTitle.appendTo($titles);
    }
    $newText.appendTo($texts);

    $paramBlock.hide();
}

function initLongDescription() {
    const $description = $("#description");
    if ($description.length === 0) {
        return;
    }

    const shopDataLayer = getShopDataLayer();
    const emptyText = shopDataLayer.productDetail.emptyDescription;
    const text = $description.text().trim();

    if (emptyText && text === emptyText) {
        $description.hide();
        return;
    }

    if (text.length === 0) {
        $description.hide();
        return;
    }

    if (shopDataLayer.productDetail.descriptionTitle) {
        $("<h2 class='description-title'>" + shopDataLayer.productDetail.descriptionTitle + "</h2>").prependTo($description);
    }
}

// Tooltipy u variantních parametrů. Pro každý záznam v shopDataLayer.productDetail.variantsTooltip
// najde #parameter-id-{id} (Shoptet select pro variantu) a přidá kruhovou ikonu "i"
// do TH řádku .variant-list. Klik otevře fullscreen overlay s HTML obsahem z dataLayer.
// Overlay se vytvoří lazy (až při prvním kliknutí), pak se jen fade in/out.
function initVariantsTooltips() {
    const shopDataLayer = getShopDataLayer();
    const items = shopDataLayer.productDetail.variantsTooltip;
    const closeLabel = shopDataLayer.buttons.close || "";
    if (!Array.isArray(items) || items.length === 0) {
        return;
    }

    items.forEach(function (item) {
        const $select = $("#parameter-id-" + item.id);
        if ($select.length === 0) {
            return;
        }
        const $th = $select.closest(".variant-list").find("> th");
        if ($th.find(".mytooltip[data='" + item.id + "']").length === 0) {
            $("<span class='mytooltip' data='" + item.id + "'>?</span>").appendTo($th);
        }
    });

    $(document).on("click", ".variant-list .mytooltip", function () {
        const id = $(this).attr("data");
        const item = items.find(function (i) { return i.id === id; });
        if (!item) {
            return;
        }

        let $window = $(".mytooltip-window[data='tooltip-" + id + "']");
        if ($window.length === 0) {
            const parameterName = $("#parameter-id-" + id).attr("data-parameter-name") || "";
            $window = $(
                "<div class='mytooltip-window' data='tooltip-" + id + "' style='display: none;'>" +
                "<div class='clickable-part'></div>" +
                "<div class='mytooltip-inner'>" +
                "<div class='close-tooltip' aria-label='" + closeLabel + "'></div>" +
                "<div class='mytooltip-inner__title'>" + parameterName + "</div>" +
                item.text +
                "</div>" +
                "</div>"
            ).appendTo(".overall-wrapper");
        }
        $window.fadeIn(300);
    });

    $(document).on("click", ".close-tooltip, .mytooltip-window .clickable-part", function () {
        $(this).closest(".mytooltip-window").fadeOut(300);
    });
}
